"use client";

import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react";
import { useTheme } from "next-themes";
import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            "bg-white border border-d-border rounded-[24px] shadow-[0px_4px_4px_0px_rgba(41,37,36,0.12)] p-4 flex gap-4 items-center w-full",
          title: "!text-d-black text-lg font-medium leading-[22px]",
          description: "!text-d-gray text-base font-medium leading-[22px]",
          icon: "bg-[#fde5da] border border-[#f5d3a5] rounded-xl shadow-[3px_3px_0px_0px_#f5d3a5] p-3 flex items-center justify-center shrink-0",
          success: "bg-white",
          error: "bg-white",
          warning: "bg-white",
          info: "bg-white",
        },
      }}
      icons={{
        success: <CircleCheckIcon className="size-6" />,
        info: <InfoIcon className="size-6" />,
        warning: <TriangleAlertIcon className="size-6" />,
        error: <OctagonXIcon className="size-6" />,
        loading: <Loader2Icon className="size-6 animate-spin" />,
      }}
      {...props}
    />
  );
};

export { Toaster };
